import styled from 'styled-components'

export const Buttons = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: end;
  gap: 16px;
  button {
    display: flex;
    align-items: center;
    height: 40px;
    border-radius: 8px;
    color: white !important;
    background-color: #0085ff !important;
    &:hover {
      background-color: #0069f2 !important;
    }
    &:disabled {
      opacity: 0.48;
    }
  }
`
